// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NavUpLightIconSignature {
  Element: SVGSVGElement;
}

export const NavUpLightIcon: TOC<NavUpLightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M22.1 17.6L12.1 7.60001L1.99999 17.7L1.29999 17L12.1 6.20001L22.8 16.9L22.1 17.6Z"/>
</svg>
</template>;